import React, { useEffect, useState } from "react";
import { Card, CardHeader, CardContent, Typography, Box } from "@mui/material";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import useData from "../hooks/SchoolInfoHook";

const CoordinatorOfOperations = ({ schoolId }) => {
  const [userInfo, setUserInfo] = useState(null);
  const { data: operationsData, loading: operationsLoading } =
    useData(schoolId);
  const db = getFirestore();

  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        if (operationsData.length > 0) {
          const operations = operationsData[0].operations;
          //console.log("Pathway:", pathway); // Log pathway

          const userDoc = await getDoc(doc(db, "users", operations));

          if (userDoc.exists()) {
            setUserInfo(userDoc.data());
            console.log("User Info:", userDoc.data()); // Log user info
          } else {
            console.error("No such document!");
          }
        }
      } catch (error) {
        console.error("Error fetching user info:", error);
      }
    };

    if (operationsData.length > 0) {
      fetchUserInfo();
    }
  }, [operationsData, db]);

  return (
    <Card>
      <CardHeader
        title="Coordinator Of Operations"
        sx={{ backgroundColor: "#AC1A2F", color: "white" }}
      />
      <CardContent>
        {operationsLoading ? (
          <Typography>Loading operations...</Typography>
        ) : userInfo ? (
          <Box display="flex" flexDirection="column" alignItems="center">
            <Typography variant="h5">{userInfo.name}</Typography>
            <Typography variant="h6">{userInfo.email}</Typography>
            <Typography variant="h6">{userInfo.phone}</Typography>
          </Box>
        ) : (
          <Typography>Loading user info...</Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default CoordinatorOfOperations;
